import { render, staticRenderFns } from "./healthplan.vue?vue&type=template&id=22a146fd&scoped=true&"
import script from "./healthplan.vue?vue&type=script&lang=js&"
export * from "./healthplan.vue?vue&type=script&lang=js&"
import style0 from "./healthplan.vue?vue&type=style&index=0&id=22a146fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a146fd",
  null
  
)

export default component.exports